<template>
  <SysDialogFullScreen
    v-model="dialog"
    titulo="Dados Compilados da Planilha"
    transition="dialog-bottom-transition"
    @click:hidden-dialog="fechar()"
  >
    <template #titulo-parte-direita>
      <v-text-field
        v-model="search"
        placeholder="Pesquisar"
        hide-details
        append-icon="mdi-magnify"
        dense
        height="25"
        background-color="#FFF"
        outlined
        class="mx-3"
        style="max-width: 350px"
      ></v-text-field>

      <v-btn
        color="primary"
        @click="save()"
      >
        <v-icon>mdi-content-save</v-icon>
        Salvar
      </v-btn>
    </template>

    <SysDataTable
      v-model="selections"
      :headers="headers"
      :items="desserts"
      :height="alturaDaJanela - 65"
      :item-height="25"
      :search="search"
      hide-default-footer
      item-key="cod_barras"
      show-select
      class="elevation-1"
    >
      <template #item.fornecador="{ value }">
        <p class="pa-0 ma-0 text-truncate">{{ value }}</p>
      </template>

      <template #item.descricao_produto="{ value }">
        <p class="pa-0 ma-0 text-truncate">{{ value }}</p>
      </template>

      <template #item.mes_1="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_2="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_3="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_4="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_5="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_6="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_7="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_8="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_9="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_10="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_11="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_12="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>

      <template #item.mes_1="{ value }">
        {{ Helpers.formatarValorComCasas(value, 2) }}
      </template>
    </SysDataTable>
  </SysDialogFullScreen>
</template>

<script>
import ImportAPI from "../../../api/imports";
import Headers from "./includes/HeadersTabelaDados";
import Responsividade from "../../../helpers/ResponsiveHeight";
import SysDataTable from '../../utils/dataTable/sysDataTable/Index.vue';
import SysDialogFullScreen from '../../padraoDeLayout/SysDialogFullScreen.vue'
export default {
  mixins: [
    Responsividade
  ],
  components: {
    SysDialogFullScreen,
    SysDataTable
  },
  props: {
    ativar: {
      type: Boolean,
      required: true
    },
    dados: {
      type: Array,
      required: true
    },
    form: {
      type: Object,
      required: true
    }
  },
  watch: {
    ativar(valor) {
      this.dialog = valor;
    },

    dados(valor) {
      this.desserts = valor;
    }
  },
  data() {
    return {
      dialog: false,
      selections: [],
      headers: Headers.tabela_temporaria,
      desserts: [],
      search: ''
    }
  },
  methods: {
    fechar() {
      this.selections = [];
      this.$emit('fechar-dialog');
    },

    save() {
      const params = {
        selecionados: this.selections.length > 0 ? this.selections : this.desserts,
        form: this.form
      };

      this.$store.dispatch("loadingAux/habilitarLoading", true);

      ImportAPI.salvarDadosTemporarioPlanilha(params)
        .then((response) => {
          const { message, dados, token } = response.data;
          localStorage.setItem("token", token);
        })
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => {
          this.$store.dispatch("loadingAux/habilitarLoading", false);
          this.fechar();
        });
    }
  }
}
</script>

<style>

</style>
